var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg3D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 82,
    viewBox: "0 0 60 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 82,
    rx: 5.85714,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.661 25.286C15.869 25.286 15.1136 25.1283 14.395 24.813C13.6763 24.4903 13.0493 24.0393 12.514 23.46C11.986 22.8807 11.6083 22.1987 11.381 21.414L14.285 20.644C14.439 21.2233 14.7396 21.6743 15.187 21.997C15.6416 22.3123 16.133 22.47 16.661 22.47C17.1156 22.47 17.53 22.36 17.904 22.14C18.2853 21.92 18.586 21.623 18.806 21.249C19.0333 20.875 19.147 20.4607 19.147 20.006C19.147 19.324 18.9123 18.741 18.443 18.257C17.981 17.7657 17.387 17.52 16.661 17.52C16.441 17.52 16.2283 17.553 16.023 17.619C15.8176 17.6777 15.6196 17.762 15.429 17.872L14.087 15.518L19.125 11.338L19.345 11.976H11.997V9.16H21.897V11.976L17.981 15.76L17.959 14.924C18.8683 15.0633 19.6346 15.3823 20.258 15.881C20.8886 16.3723 21.3653 16.981 21.688 17.707C22.018 18.4257 22.183 19.192 22.183 20.006C22.183 21.0033 21.93 21.9017 21.424 22.701C20.918 23.493 20.247 24.1237 19.411 24.593C18.575 25.055 17.6583 25.286 16.661 25.286Z",
    fill: "#2B65CF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.75 39C24.1525 39 17 46.1525 17 47.75C17 46.1525 9.84751 39 8.25 39C9.84751 39 17 31.8475 17 30.25C17 31.8475 24.1525 39 25.75 39Z",
    fill: "#2B65CF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.75 59C49.8745 59 37 71.8745 37 74.75C37 71.8745 24.1255 59 21.25 59C24.1255 59 37 46.1255 37 43.25C37 46.1255 49.8745 59 52.75 59Z",
    fill: "#2B65CF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3D);
export default __webpack_public_path__ + "static/media/3d.c506905a976a6d16926a503c4ee3d44c.svg";
export { ForwardRef as ReactComponent };